export default __webpack_public_path__ + "a49cda8.svg";